import { CalendarClock, Gauge, ShieldCheck } from "lucide-react";
import Booking from "./Booking";
import ServicePageFaqSection from "./ServicePageFaqSection";
import { useFaqPageJsonLd } from "@/hooks/useFaqPageJsonLd";

export default function TachographPage({ t }) {
  useFaqPageJsonLd(t.tachographPage.faq, "service-tachograph-faq");

  return (
    <article
      id="tachograph-page"
      data-testid="tachograph-page"
      className="bg-white border-b border-[#e2e6ec]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <header>
          <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#e3191b] mb-4">
            {t.tachographPage.eyebrow}
          </div>
          <h1 className="font-[Barlow_Condensed] font-bold uppercase tracking-tight text-[#0b1220] text-5xl sm:text-6xl lg:text-7xl leading-[0.95]">
            {t.tachographPage.title}
          </h1>
          <p className="mt-6 max-w-3xl text-slate-600 leading-relaxed text-base sm:text-lg">
            {t.tachographPage.lead}
          </p>
          {t.tachographPage.secondary ? (
            <p className="mt-5 max-w-3xl text-slate-600 leading-relaxed text-base sm:text-lg">
              {t.tachographPage.secondary}
            </p>
          ) : null}
        </header>

        <section className="mt-12" aria-labelledby="tachograph-cards-heading">
          <h2
            id="tachograph-cards-heading"
            className="font-[Barlow_Condensed] font-bold uppercase tracking-tight text-[#0b1220] text-2xl sm:text-3xl mb-8 max-w-4xl leading-tight"
          >
            {t.tachographPage.cardsSectionTitle}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            <div className="border border-[#e2e6ec] bg-white p-6">
              <div className="inline-flex items-center gap-2 text-[#0b378c] font-mono text-xs uppercase tracking-[0.25em] mb-3">
                <Gauge className="w-4 h-4" />
                {t.tachographPage.card1Title}
              </div>
              <p className="text-sm text-slate-600 leading-relaxed">{t.tachographPage.card1Text}</p>
            </div>
            <div className="border border-[#e2e6ec] bg-white p-6">
              <div className="inline-flex items-center gap-2 text-[#0b378c] font-mono text-xs uppercase tracking-[0.25em] mb-3">
                <CalendarClock className="w-4 h-4" />
                {t.tachographPage.card2Title}
              </div>
              <p className="text-sm text-slate-600 leading-relaxed">{t.tachographPage.card2Text}</p>
            </div>
            <div className="border border-[#e2e6ec] bg-white p-6">
              <div className="inline-flex items-center gap-2 text-[#0b378c] font-mono text-xs uppercase tracking-[0.25em] mb-3">
                <ShieldCheck className="w-4 h-4" />
                {t.tachographPage.card3Title}
              </div>
              <p className="text-sm text-slate-600 leading-relaxed">{t.tachographPage.card3Text}</p>
            </div>
          </div>
        </section>

        <ServicePageFaqSection
          headingId="tachograph-faq-heading"
          title={t.tachographPage.faqTitle}
          faq={t.tachographPage.faq}
        />

        <div className="mt-12">
          <Booking
            t={t}
            initialService={t.services.items.find((item) => item.code === "S/09")?.title || ""}
            copyOverrides={t.tachographPage.bookingCopy}
          />
        </div>
      </div>
    </article>
  );
}
